export const dispatchType = {
  default: {
    text: 'text-muted',
    background: 'bg-primitive-white',
  },
  active: {
    text: 'text-brand-primary-base',
    background: 'bg-brand-primary-muted',
  },
};
